import React, { useState } from 'react';
import { LayoutChangeEvent, StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNAButtonGroup, DNAContextMenu, DNAText, Iffy } from '@alucio/lux-ui';
import { CommonIcon } from 'src/components/DNA';

export const S = StyleSheet.create({
  contextMenuItems: {
    top: 4,
  },
  // REVIEW REPLACE BUTTON
  updatedIcon: {
    marginRight: 6,
  },
  updatedText: {
    fontWeight: '700',
  },
})

enum ButtonVariantEnum {
  RemoveSlide = 'RemoveSlide',
  ReviewReplace = 'ReviewReplace',
  FindReplacement = 'FindReplacement',
  InsertText = 'InsertText',
}
export type ButtonVariant = keyof typeof ButtonVariantEnum

type ThumbnailFooterButtonProps = {
  variant: ButtonVariant,
  onPress?: () => void,
  onPressSecondaryBtn?: () => void,
}

const ThumbnailFooterButton: React.FC<ThumbnailFooterButtonProps> = ({
  variant,
  onPress,
  onPressSecondaryBtn,
}) => {
  const [removeSlideMenuWidth, setRemoveSlideMenuWidth] = useState<number>(0);

  const handleRemoveSlideContainerLayout = (event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout;
    setRemoveSlideMenuWidth(width); // Add extra padding if necessary
  };

  return (
    <>
      {/* REMOVE SLIDE BUTTON */}
      <Iffy is={variant === ButtonVariantEnum.RemoveSlide}>
        <DNABox fill onLayout={handleRemoveSlideContainerLayout}>
          <DNAButtonGroup fill>
            <DNAButton
              status="warning"
              iconLeft="trash"
              onPress={onPress}
              children="Remove"
              stretch
            />
            <DNAContextMenu
              style={[S.contextMenuItems, { width: removeSlideMenuWidth }]}
              placement="bottom end"
            >
              <DNAContextMenu.Anchor>
                <DNAButton
                  status="warning"
                  iconLeft="caret-down"
                  onPress={() => { }}
                />
              </DNAContextMenu.Anchor>
              <DNAContextMenu.Items>
                <DNAContextMenu.Item
                  collapseOnPress
                  delay={100}
                  title="Remove all unavailable slides"
                  onPress={onPressSecondaryBtn || (() => {})}
                />
              </DNAContextMenu.Items>
            </DNAContextMenu>
          </DNAButtonGroup>
        </DNABox>
      </Iffy>
      {/* REVIEW OR REPLACE BUTTON */}
      <Iffy is={variant === ButtonVariantEnum.ReviewReplace}>
        <DNAButton
          testID="review-or-replace-button"
          appearance="outline"
          status="tertiary"
          onPress={onPress}
          children="Review or replace"
          stretch
        />
        <DNABox alignX="center" alignY="center">
          <CommonIcon
            testID="updated_slide_icon"
            variant="check"
            style={S.updatedIcon}
          />
          <DNAText
            p1
            status="success"
            style={S.updatedText}
          >
            Updated
          </DNAText>
        </DNABox>
      </Iffy>
      {/* FIND REPLACEMENT BUTTON */}
      <Iffy is={variant === ButtonVariantEnum.FindReplacement}>
        <DNAButton
          testID="find-and-replace-button"
          status="warning"
          iconLeft="arrows-clockwise"
          onPress={onPress}
          children="Find replacement"
          stretch
        />
      </Iffy>
      {/* INSERT TEXT BUTTON */}
      <Iffy is={variant === ButtonVariantEnum.InsertText}>
        <DNAButton
          testID="insert-text-on-slide-button"
          appearance="outline"
          status="tertiary"
          onPress={onPress}
          children="Insert text on slide"
          stretch
        />
      </Iffy>
    </>
  )
}

export default ThumbnailFooterButton;
